/**
 * 语言选项配置及传参工具
 */
export const languageOptions = [ 
  { value: 'zh', label: '简体中文' },
  { value: 'zh-TW', label: '繁体中文' },
  { value: 'en', label: '英语' },
  { value: 'ja', label: '日语' },
  { value: 'ko', label: '韩语' },
  { value: 'fr', label: '法语' },
  { value: 'de', label: '德语' },
  { value: 'es', label: '西班牙语' },
  { value: 'pt', label: '葡萄牙语' },
  { value: 'ru', label: '俄语' },
  { value: 'it', label: '意大利语' },
  { value: 'ar', label: '阿拉伯语' },
  { value: 'hi', label: '印地语' },
  { value: 'fa', label: '波斯语' },
  { value: 'tr', label: '土耳其语' },
  { value: 'vi', label: '越南语' },
  { value: 'th', label: '泰语' },
  { value: 'id', label: '印尼语' },
  { value: 'ms', label: '马来语' },
  { value: 'nl', label: '荷兰语' },
  { value: 'sv', label: '瑞典语' },
  { value: 'da', label: '丹麦语' },
  { value: 'no', label: '挪威语' },
  { value: 'fi', label: '芬兰语' },
  { value: 'pl', label: '波兰语' },
  { value: 'cs', label: '捷克语' },
  { value: 'hu', label: '匈牙利语' },
  { value: 'ro', label: '罗马尼亚语' },
  { value: 'el', label: '希腊语' },
]

const languageLabelMap: Record<string, string> = Object.fromEntries(
  languageOptions.map((opt) => [opt.value, opt.label])
)

/**
 * 根据语言 code 获取 extParams.info 中的语言描述文本
 * @param langCode 语言 code，如 'zh'、'en'
 * @returns 如 '语言:中文（简体）'
 */
export function getLanguageInfoText(langCode: string): string {
  const label = languageLabelMap[langCode] ?? langCode
  return `语言:${label}`
}
